function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4b4b4b;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Lager_2",
  "data-name": "Lager 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "_\\xCE\\xD3\\xC8_1",
  "data-name": "\\u2014\\xCE\\xD3\\xC8_1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M84.66,95.33A153.75,153.75,0,0,1,7.82,74.79,15.84,15.84,0,0,1,1.5,54.41l22.67-48a11.21,11.21,0,0,1,15.1-5.25,101.3,101.3,0,0,0,45.39,10.6,101.31,101.31,0,0,0,45.4-10.6,11.21,11.21,0,0,1,15.1,5.25l22.67,48h0a15.84,15.84,0,0,1-6.32,20.38A153.76,153.76,0,0,1,84.66,95.33ZM34.3,3.58A7.79,7.79,0,0,0,31.79,4,7.61,7.61,0,0,0,27.4,8l-22.66,48A12.25,12.25,0,0,0,9.61,71.69,150.25,150.25,0,0,0,84.66,91.75a150.26,150.26,0,0,0,75.06-20.06,12.25,12.25,0,0,0,4.87-15.75L141.93,8a7.63,7.63,0,0,0-10.28-3.57,104.85,104.85,0,0,1-47,11,104.84,104.84,0,0,1-47-11A7.6,7.6,0,0,0,34.3,3.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M104.53,94.05a1.89,1.89,0,0,1-.69-.14,1.8,1.8,0,0,1-1-2.34l11.29-27.25a1.79,1.79,0,0,1,3.31,1.37L106.18,92.94A1.79,1.79,0,0,1,104.53,94.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M35.83,87.32a1.89,1.89,0,0,1-.69-.14,1.8,1.8,0,0,1-1-2.34l8.5-20.52A1.79,1.79,0,0,1,46,65.69l-8.5,20.52A1.78,1.78,0,0,1,35.83,87.32Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M101.91,72.56a1.8,1.8,0,0,1-.69-3.45L149.29,49.2a1.79,1.79,0,0,1,1.38,3.31L102.6,72.42A1.89,1.89,0,0,1,101.91,72.56Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M30.42,72.56a1.79,1.79,0,0,1-.68-3.45L77.81,49.2a1.79,1.79,0,1,1,1.37,3.31L31.11,72.42A1.89,1.89,0,0,1,30.42,72.56Z"
})));

function SvgWipers(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 169.33 95.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWipers);
export default __webpack_public_path__ + "static/media/wipers.1c0afaba.svg";
export { ForwardRef as ReactComponent };